import { GoEye } from "react-icons/go";
import useSearchPagination from "../../../../ReusableComponents/SearchPagination/useSearchPagination";
import { useState } from "react";
import { useNavigate } from "react-router-dom";
import nodeinstance from "../../../../nodeInstance";
import { useDispatch } from "react-redux";
import { setAppError } from "../../../../store/userSlice";

export default function Additional_apporval({
  dependentDetails,
  setTrigger,
  trigger,
  setIndex,
  titles,
  setDetails,
}) {
  const {
    NoDataFound,
    Pagination,
    PaginationIndex,
    Search,
    CountPerPage,
    currentList,
  } = useSearchPagination(dependentDetails?.data || []);
  const [searchWords, setSearchWords] = useState([]);
  const navigate = useNavigate();
  const handleIconClick = (value) => {
    setDetails(value);
    navigate("/dashboard/dependent-addition/Additional_apporval");
  };
  const [downloadLoading, setDownloadLoading] = useState(false);
  const dispatch = useDispatch();
  const token = localStorage.getItem("nodeToken");
  const downloadFile = async () => {
    setDownloadLoading(true);
    try {
      const response = await nodeinstance.get(
        `/insurance-dependent/excelDownload/FINANCE`,
        {
          responseType: "blob",
          headers: {
            Authorization: `Bearer ${token}`,
          },
        }
      );
      if (response.status === 200) {
        const url = window.URL.createObjectURL(response.data);
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", `OPS_2_REPORT_FINANCE`);
        document.body.appendChild(link);
        link.click();
        dispatch(
          setAppError({
            msg: "Excel Downloaded",
            color: "success",
          })
        );
        setDownloadLoading(false);
      } else {
        throw new Error("Something went wrong!");
      }
    } catch (err) {
      setDownloadLoading(false);
      dispatch(
        setAppError({
          msg: err.message,
        })
      );
    }
  };
  const formatDate = (dateString) => {
    const date = new Date(dateString);
    if (isNaN(date.getTime())) {
      return "Invalid Date";
    }
    const monthNames = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];
    const day = date.getDate();
    const monthName = monthNames[date.getMonth()];
    const year = date.getFullYear();
    return `${day}-${monthName.toLowerCase()}-${year}`;
  };

  const [fileter, setFilter] = useState("");
  console.log("filter date should be poppulated here....", fileter);
  const formattedInputDate = fileter ? formatDate(fileter) : "";

  // Filter the list based on the iqama expiry date if input date is provided
  const filteredList = !fileter
    ? dependentDetails?.data
    : dependentDetails?.data.filter((list) => {
        const formattedIqamaExpiryDate = formatDate(list.iqama_expiry_date_g);
        return formattedIqamaExpiryDate === formattedInputDate;
      });
  return (
    <>
      <div className="flex gap-x-4 mt-4">
        <Search
          searchKey={[
            "employee_id",
            "passport_number",
            "iqama_number",
            "client_id",
            "emp_id",
            "sponsor_id",
          ]}
          setSearchWords={setSearchWords}
        />
        <button
          className="bg-black text-white px-4 rounded-md py-2 text-sm h-[36px]"
          onClick={() => downloadFile()}
        >
          DOWNLOAD
        </button>
        <input
          type="date"
          className="px-4 rounded-md "
          onChange={(e) => {
            setFilter(e.target.value);
          }}
        />
      </div>

      <div
        className="overflow-x-auto mt-10"
        style={{ backgroundColor: "white" }}
      >
        <table className="min-w-full divide-gray-200">
          <thead className="bg-gray-100">
            <tr>
              {titles.map((columnName, index) => (
                <th
                  key={index}
                  scope="col"
                  className="px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider font-semibold"
                >
                  {columnName}
                </th>
              ))}
            </tr>
          </thead>
          <tbody className="bg-white divide-gray-10">
            {filteredList?.map((listItem, index) => (
              <tr key={index}>
                <td className="px-6 py-4 whitespace-nowrap">{index + 1}</td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.request_type}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.employee_count
                    ? listItem?.employee_count
                    : "------"}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.employee_name}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.emp_id}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.gender}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem.nationality}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.actual_profession}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.client_name}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.iqama_number}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {String(listItem.iqama_expiry_date_g)}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.project}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  {listItem?.insurance_class}
                </td>
                <td className="px-6 py-4 whitespace-nowrap">
                  <button
                    onClick={() => {
                      handleIconClick(listItem);
                    }}
                  >
                    <GoEye fontSize={22} />
                  </button>
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>

      <Pagination />
    </>
  );
}
